/**
 * Shared constants and re-exports for type validators.
 * All validators use the same stage number and issue helpers.
 */

import type { ValidationIssue, PipelineStage } from '../../issueContract'
import { blocker, coach, info } from '../../issueContract'

export const STAGE: PipelineStage = 1 // Stage 1b shares stage number with schema

export { blocker, coach, info }
export type { ValidationIssue }
